import React from 'react';
import { Box, Typography, Grid, useTheme, Stack } from '@mui/material';
import {
  SmartToy,
  Timeline,
  Description,
  TouchApp,
  Person,
  BusinessCenter,
  Gavel,
  BarChart,
} from '@mui/icons-material';

const features = [
  {
    icon: <SmartToy fontSize="large" color="secondary" />,
    title: 'AI, който работи за вас',
    subtitle: 'Оценка на имота за секунди – бърза, точна и автоматизирана.',
  },
  {
    icon: <Timeline fontSize="large" color="secondary" />,
    title: 'Актуални пазарни данни всеки ден',
    subtitle: 'Бъдете в крак с пазара – нашият модел се обновява ежедневно.',
  },
  {
    icon: <Description fontSize="large" color="secondary" />,
    title: 'Персонализирани имотни отчети',
    subtitle: 'Изберете какво ви интересува и получете отчет, създаден за вас.',
  },
  {
    icon: <TouchApp fontSize="large" color="secondary" />,
    title: 'Лесна и интуитивна платформа',
    subtitle: 'Ясна навигация и удобен интерфейс – без нужда от технически познания.',
  },
];

const audiences = [
  {
    icon: <Person fontSize="large" color="secondary" />,
    title: 'Собственици, които искат да продават имота си',
    subtitle: 'Научете реалната пазарна стойност и преговаряйте уверено.',
  },
  {
    icon: <BusinessCenter fontSize="large" color="secondary" />,
    title: 'Агенти на недвижими имоти',
    subtitle: 'Впечатлете клиентите с точни оценки и пестете време.',
  },
  {
    icon: <Gavel fontSize="large" color="secondary" />,
    title: 'Лицензирани оценители',
    subtitle: 'Използвайте AI като ориентир и допълнение към експертизата ви.',
  },
  {
    icon: <BarChart fontSize="large" color="secondary" />,
    title: 'Инвеститори и анализатори',
    subtitle: 'Следете тенденции и намирайте подценени имоти чрез данни.',
  },
];

const Services = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.secondary,
        padding: theme.custom?.padding?.primary || '30px',
        borderRadius: '16px',
      }}
    >
      <Typography
        variant="h5"
        fontWeight="bold"
        color={theme.palette.secondary.other}
        gutterBottom
        textAlign="center"
      >
        Какво ви предлагаме
      </Typography>

      <Grid container spacing={4} mt={2}>
        {features.map((feature, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Box
              sx={{
                backgroundColor: theme.palette.primary.another,
                borderRadius: '12px',
                padding: '24px',
                height: '100%',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
                textAlign: 'center',
              }}
            >
              <Stack spacing={1} alignItems="center">
                {feature.icon}
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  color={theme.palette.secondary.other}
                >
                  {feature.title}
                </Typography>
                <Typography
                  variant="body2"
                  color={theme.palette.secondary.other}
                  sx={{ opacity: 0.8 }}
                >
                  {feature.subtitle}
                </Typography>
              </Stack>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Typography
        variant="h6"
        fontWeight="bold"
        color={theme.palette.secondary.other}
        gutterBottom
        textAlign="center"
        mt={6}
        padding={theme.padding.primary.main}
      >
        За кого е подходяща платформата?
      </Typography>

      <Grid container spacing={4} mt={2}>
        {audiences.map((audience, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Box
              sx={{
                backgroundColor: theme.palette.primary.another,
                borderRadius: '12px',
                padding: '24px',
                height: '100%',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
                textAlign: 'center',
              }}
            >
              <Stack spacing={1} alignItems="center">
                {audience.icon}
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  color={theme.palette.secondary.other}
                >
                  {audience.title}
                </Typography>
                <Typography
                  variant="body2"
                  color={theme.palette.secondary.other}
                  sx={{ opacity: 0.8 }}
                >
                  {audience.subtitle}
                </Typography>
              </Stack>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Services;
